<template>
  <el-dialog
    v-drag
    title="修改"
    :visible.sync="dialogVisible"
    width="440px"
    :show-close="true"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
  >
    <div class="content" :loading="loading">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-position="top"
        label-width="80px"
      >
        <el-form-item label="卸货港" prop="dischargeHarbor">
          <el-select
            v-model="form.dischargeHarbor"
            filterable
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option
              v-for="(item, $index) in dischargeHarborOptions"
              :key="$index"
              :label="item.label"
              :value="item.label"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="卸货港日期" prop="dischargeHarborDate">
          <el-date-picker
            v-model="form.dischargeHarborDate"
            type="datetime"
            placeholder="请选择到卸货港日期"
            style="width: 100%"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="操作" prop="operator">
          <el-select
            v-model="form.operator"
            multiple
            filterable
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option
              v-for="item in operatorOptions"
              :key="item.id"
              :label="item.nameCH"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="客服" prop="customer">
          <el-select
            v-model="form.customer"
            multiple
            filterable
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option
              v-for="item in customerOptions"
              :key="item.id"
              :label="item.nameCH"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="财务" prop="financer">
          <el-select
            v-model="form.financer"
            multiple
            filterable
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option
              v-for="item in financerOptions"
              :key="item.id"
              :label="item.nameCH"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="footers">
      <div class="cancel flex_c_c" @click="cancel">取 消</div>
      <div class="ok flex_c_c" @click="ok('form')">确 定</div>
    </span>
  </el-dialog>
</template>
<script>
import config from '@/utils/config'
import { mblHandler, updateMBLHandler } from '@/api/bill'
import { getUserForType } from '@/api/system'
import { mapGetters } from 'vuex'
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      config,
      form: {
        operator: [],
        customer: [],
        financer: []
      },
      loading: false,
      rules: {
        operator: [{ required: true, message: '请选择操作', trigger: 'blur' }],
        customer: [{ required: true, message: '请选择客服', trigger: 'blur' }],
        financer: [{ required: true, message: '请选择财务', trigger: 'blur' }]
      },
      userOptions: []
    }
  },
  computed: {
    ...mapGetters([
      'shipDestinPortOptions',
      'airDestinPortOptions'
    ]),
    operatorOptions() {
      return this.userOptions.filter((a) => [99, 100].includes(a.type))
    },
    financerOptions() {
      return this.userOptions.filter((a) =>
        [201, 202, 203, 204].includes(a.type)
      )
    },
    customerOptions() {
      return this.userOptions.filter((a) => [103, 104].includes(a.type))
    },
    dischargeHarborOptions() {
      if (this.rowData.type) {
        return this.airDestinPortOptions
      } else {
        return this.shipDestinPortOptions
      }
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.getUserForType()
        this.getData()
      }
    }
  },
  mounted() {
    if (
      !(this.shipDestinPortOptions && this.shipDestinPortOptions.length > 0)
    ) {
      this.$store.dispatch('getShipDestinPortOptions')
    }
    if (!(this.airDestinPortOptions && this.airDestinPortOptions.length > 0)) {
      this.$store.dispatch('getAirDestinPortOptions')
    }
  },
  methods: {
    async getUserForType() {
      try {
        const res = await getUserForType({})
        if (res.success) {
          this.userOptions = res.data
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    async getData() {
      try {
        const res = await mblHandler({ mblId: this.rowData.id })
        if (res.success) {
          const operator = res.data
            ?.filter((a) => a.type === 0)
            .map((a) => a.userId)
          const customer = res.data
            ?.filter((a) => a.type === 2)
            .map((a) => a.userId)
          const financer = res.data
            ?.filter((a) => a.type === 1)
            .map((a) => a.userId)
          this.form = {
            operator,
            customer,
            financer
          }
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    async cancel() {
      this.$refs['form'].resetFields()
      this.$emit('cancel')
    },
    ok(formName) {
      this.$refs[formName].validate(async(valid) => {
        if (valid) {
          try {
            const operator = this.form.operator.map((a) => {
              return {
                userId: a,
                type: 0
              }
            })
            const customer = this.form.customer.map((a) => {
              return {
                userId: a,
                type: 2
              }
            })
            const financer = this.form.financer.map((a) => {
              return {
                userId: a,
                type: 1
              }
            })
            const params = {
              mblId: this.rowData.id,
              users: [...operator, ...customer, ...financer]
            }
            const res = await updateMBLHandler(params)
            if (res.success) {
              this.$message.success('操作成功')
              this.$emit('ok')
              this.$refs[formName].resetFields()
            } else {
              this.$message.error(res.errorMessage)
            }
          } catch (error) {
            console.error(error)
          }
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.content {
  width: 320px;
  margin: 0 auto;
}
.footers {
  width: 100%;
  display: flex;
  justify-content: center;
  .cancel {
    width: 120px;
    height: 40px;
    background: #eeeeee;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    margin-right: 16px;
    cursor: pointer;
  }
  .ok {
    width: 120px;
    height: 40px;
    background: rgb(18, 88, 188);
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    cursor: pointer;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
  }
}
</style>
